import type { CSSProperties } from "react";

export const INK = "#000000";
export const DARK = "#1A2332";
export const LINE = "#E7EAF0";
export const LINE_STRONG = "#D1D5DB";
export const BG = "#F4F6F8";
export const CARD = "#FFFFFF";
export const TEAL = "#15A08C";
export const TEAL_INK = "#0B7377";

export const ghostBtn: CSSProperties = {
  background: "transparent",
  border: "none",
  color: DARK,
  padding: "8px 12px",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 13,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  fontFamily: "inherit",
  fontWeight: 700,
};